// libraries.
import { toast } from 'react-toastify';
import { PolygonF } from '@react-google-maps/api';
import { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// selectors.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { getMedianZoneCode } from '@domains/median-zones/store/slices/medianZones.slice';
import { getListPolygons } from '@domains/save-polygons';
// hooks.
import { useGetPolygonsByMedianZoneQuery } from '@domains/save-polygons/store/api-slices/getPolygons.endpoints';
import { setListPolygons } from '@domains/save-polygons/store/slices/modePolygon.slice';

// utils.
import { optionsPolygons } from '../ListPolygons/utils/optionsPolygons';
import { getRadiusByCountry } from '@domains/save-polygons/store/api-slices/utils';
import { PolygonIdLabel } from '@domains/google-map';
import { getPolygonStyle, getPolygonTypeFilter } from '@domains/polygon-tool';

export const PolygonsViewer = () => {
  const dispatch = useDispatch();
  const country = useSelector(getCountry);
  const medianZoneCode = useSelector(getMedianZoneCode);
  const polygonsList = useSelector(getListPolygons);
  const polygonTypeFilter = useSelector(getPolygonTypeFilter);
  const radius = getRadiusByCountry(country, polygonTypeFilter);

  const { data, isFetching, isError } = useGetPolygonsByMedianZoneQuery(
    {
      country: country,
      median_zone: medianZoneCode,
      polygon_type: polygonTypeFilter,
      radius: radius,
    },
    { skip: !medianZoneCode }
  );

  useEffect(() => {
    if (isFetching) {
      toast.loading('Cargando polígonos...', {
        toastId: 'loadingPolygonsList',
      });
    } else {
      toast.dismiss('loadingPolygonsList');
    }
  }, [isFetching]);

  useEffect(() => {
    if (isError) {
      toast.error('Error obteniendo polígonos');
    }
  }, [isError]);

  useEffect(() => {
    if (data) {
      dispatch(setListPolygons(data));
    }
  }, [data, dispatch]);

  return (
    <>
      {polygonsList.map(polygon => {
        if (polygon.hidden) return null;

        const path = polygon.polygon.map(point => ({
          lat: point.lat,
          lng: point.lng,
        }));

        const polygonOptions =
          polygon.polygon_type === 'blocking'
            ? { ...getPolygonStyle('blocking'), zIndex: 100 }
            : optionsPolygons;

        return (
          <Fragment key={polygon.polygon_id}>
            <PolygonF path={path} options={polygonOptions} />
            <PolygonIdLabel id={polygon.polygon_id} path={path} />
          </Fragment>
        );
      })}
    </>
  );
};
